import { useId as useReactId } from 'react';

/** Thin wrapper around React 18+ `useId` that prefixes with `vq-` for
 *  easier debugging when multiple libraries coexist in a DOM. Returns a
 *  stable string across re-renders, SSR-safe. */
export function useId(prefix = 'vq'): string {
  const id = useReactId();
  return `${prefix}-${id.replace(/[:]/g, '')}`;
}
